(function () {
  const buttons = document.querySelectorAll('.tab-buttons button');
  const contents = document.querySelectorAll('.tab-content');

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      let currentActiveButton = document.querySelector('.tab-buttons button.active');
      currentActiveButton.classList.remove('button--primary');
      currentActiveButton.classList.add('button--secondary');

      buttons.forEach((btn) => btn.classList.remove('active'));
      contents.forEach((content) => content.classList.remove('active'));

      button.classList.add('active');
      button.classList.add('button--primary');
      button.classList.remove('button--secondary');
      const index = button.getAttribute('data-tab');
      if (contents[index]) {
        contents[index].classList.add('active');
      }
    });
  });
})();
